import script from "./MultiSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiSelect.vue?vue&type=script&setup=true&lang=js"

import "./MultiSelect.vue?vue&type=style&index=0&id=18d2ed2c&lang=scss"

const __exports__ = script;

export default __exports__